// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4e070e37","573":"b0264e21"}[chunkId] + ".chunk.js";
};